import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { RefertusLogo } from '@/components/ui/RefertusLogo';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from '@/lib/router-compat';
import { useState } from 'react';
import { ApiRequestForm } from '@/components/integrations/ApiRequestForm';
import { IntegrationScenarios } from '@/components/integrations/IntegrationScenarios';
import { SEOHead } from '@/components/SEOHead';

export default function Integrations() {
  const navigate = useNavigate();
  const [formOpen, setFormOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Integration Pack Refertius — Integra Refertius nel tuo Gestionale Medico"
        description="Richiedi l'Integration Pack Refertius: chiavi API Sandbox e Live, endpoint REST v1 e FHIR R4, snippet cURL/Python/JS, SDK e guida tecnica inviati direttamente all'IT della tua struttura."
        keywords="integration pack refertius, sandbox api refertius, API gestionale medico, REST API sanitaria, FHIR R4 cliniche, integrazione cartella clinica elettronica"
      />

      {/* Header */}
      <header className="sticky top-0 z-50 bg-background/95 backdrop-blur-xs border-b border-border">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <button onClick={() => navigate('/')} className="cursor-pointer">
            <RefertusLogo size="sm" />
          </button>

          <div className="flex items-center gap-3">
            <Button onClick={() => navigate('/auth?register=1')} className="gap-2">
              Inizia Ora
              <ArrowRight className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </header>

      {/* Main content */}
      <section className="py-8 sm:py-12 lg:py-16 px-4">
        <div className="container mx-auto max-w-3xl">
          {/* Intro */}
          <div className="text-center mb-10 sm:mb-12">
            <Badge variant="secondary" className="mb-4">Quick Start</Badge>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif text-muted-foreground mb-4">
              Richiedi l'Integration Pack
            </h1>
            <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
              Un'unica richiesta dalla direzione della struttura. Il nostro team invia direttamente all'IT due chiavi API (Sandbox per i test e Live per la produzione), endpoint REST e FHIR R4, snippet pronti all'uso, link SDK e documentazione tecnica completa — tutto ciò che serve per integrare Refertius con il gestionale della struttura o con software custom, senza toccare i dati di produzione.
            </p>
          </div>

          {/* Single action card — Integration Pack */}
          <div className="mb-10">
            <Card className="p-6 sm:p-8 flex flex-col items-start max-w-xl mx-auto">
              <h2 className="font-serif text-2xl text-primary mb-2">Integration Pack</h2>
              <p className="text-sm text-muted-foreground mb-6">
                Un'unica richiesta. Il nostro team invia all'IT della sua struttura tutto il necessario per integrare Refertius con il gestionale della struttura o con software custom: chiavi API <strong>Sandbox</strong> e <strong>Live</strong>, endpoint REST v1 e FHIR R4, snippet cURL/Python/JS, link SDK e guida tecnica. La Sandbox è inclusa gratuitamente per testare l'integrazione end-to-end senza costi e senza dati reali.
              </p>
              <Button
                className="gap-2 w-full"
                onClick={() => setFormOpen(true)}
              >
                Richiedi Integration Pack
                <ArrowRight className="h-4 w-4" />
              </Button>
            </Card>
          </div>

          <ApiRequestForm open={formOpen} onOpenChange={setFormOpen} type="integration_pack" />
        </div>
      </section>

      {/* 3 scenari pubblici di integrazione */}
      <IntegrationScenarios />

      {/* Footer */}
      <footer className="py-8 border-t border-border px-4">
        <div className="container mx-auto max-w-6xl flex flex-col sm:flex-row items-center justify-between gap-4">
          <RefertusLogo size="sm" />
          <div className="flex gap-6 text-sm text-muted-foreground">
            <button onClick={() => navigate('/privacy')} className="hover:text-primary">Privacy</button>
            <button onClick={() => navigate('/termini')} className="hover:text-primary">Termini</button>
            <button onClick={() => navigate('/prezzi')} className="hover:text-primary">Prezzi</button>
          </div>
        </div>
      </footer>
    </div>
  );
}
